import { render, staticRenderFns } from "./SortOrderTableBasic.vue?vue&type=template&id=3b9038d1&"
import script from "./SortOrderTableBasic.vue?vue&type=script&lang=js&"
export * from "./SortOrderTableBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports